export const articles = [
  {
    id: 1,
    title: "2026年最值得期待的十部国产大片，每一部都是视觉盛宴",
    summary: "从科幻巨制到历史传奇，2026年的中国电影市场注定精彩纷呈。我们为你盘点了今年最不容错过的十部国产大片。",
    content: `2026年，中国电影市场持续蓬勃发展，多部重磅大片蓄势待发。从科幻到历史，从动作到动画，类型丰富多样。

<h2>科幻巨制领衔</h2>
<p>《流浪地球3》无疑是今年最受瞩目的科幻电影。作为中国科幻电影的标杆之作，第三部将继续讲述人类在宇宙中的冒险故事。导演郭帆透露，本作的视觉效果将再次升级，为观众带来前所未有的视听体验。</p>

<h2>神话史诗新篇章</h2>
<p>《封神第二部》延续第一部的宏大叙事，将展现更加壮观的仙魔大战。乌尔善导演对古代神话的现代诠释，让这部作品既有文化底蕴又充满视觉冲击力。</p>

<h2>动画电影崛起</h2>
<p>国产动画电影近年来的进步有目共睹。今年多部动画大片即将上映，不仅在技术上追赶国际水准，在故事讲述上也更加成熟。</p>`,
    category: "影评",
    author: "电影达人小王",
    date: "2026-08-08",
    readCount: 12860,
    image: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20red%20velvet%20seats%20and%20large%20screen%2C%20warm%20golden%20lighting%2C%20elegant%20atmosphere%2C%20empty%20theater%20with%20dramatic%20lighting%2C%20clean%20minimal%20composition&width=1200&height=600&seq=article-img-01&orientation=landscape",
    slug: "2026-guochang-dapian",
    tags: ["国产电影", "科幻", "2026", "大片推荐"]
  },
  {
    id: 2,
    title: "《哪吒之魔童闹海》票房破50亿，国产动画电影的里程碑",
    summary: "《哪吒之魔童闹海》以惊人的票房成绩证明了中国动画电影的强大市场号召力和创作实力。",
    content: `<p>《哪吒之魔童闹海》自上映以来，票房一路高歌猛进，截至目前已经突破50亿大关，成为中国影史动画电影票房冠军。</p>

<h2>口碑与票房双丰收</h2>
<p>影片不仅在票房上取得了巨大成功，在观众口碑方面同样表现出色。豆瓣评分高达9.2分，被誉为"国产动画的新高度"。</p>

<h2>技术突破</h2>
<p>导演饺子带领团队在动画技术上实现了重大突破。影片中精美的画面、流畅的动作和震撼的特效场景，展现了中国动画工业的飞速进步。</p>

<h2>文化自信的体现</h2>
<p>《哪吒》系列的成功，不仅仅是商业上的胜利，更是中国文化自信的体现。传统神话故事在现代动画技术下的重新演绎，让更多年轻人对中华文化产生了浓厚兴趣。</p>`,
    category: "资讯",
    author: "影视观察员",
    date: "2026-07-25",
    readCount: 23500,
    image: "https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20box%20office%20celebration%20concept%2C%20golden%20trophy%20and%20film%20reels%2C%20warm%20golden%20lighting%2C%20cinematic%20atmosphere%2C%20elegant%20minimal%20composition%2C%20clean%20background&width=1200&height=600&seq=article-img-02&orientation=landscape",
    slug: "nezha-piaofang-50yi",
    tags: ["哪吒", "动画电影", "票房", "国产动画"]
  },
  {
    id: 3,
    title: "暑期档观影指南：这五部电影让你清凉一夏",
    summary: "炎炎夏日，走进电影院吹着空调看场好电影，简直是夏天最惬意的消遣方式。来看看暑期档有哪些值得一看的影片。",
    content: `<p>暑期档是电影市场最热闹的时段之一，各大片方纷纷拿出压箱底的好作品。今年的暑期档同样精彩纷呈。</p>

<h2>动作片：肾上腺素狂飙</h2>
<p>《红海行动2》绝对是暑期档最燃的动作大片。林超贤导演再次打造了一部硬核军事动作片，场面宏大，节奏紧凑，让人看得热血沸腾。</p>

<h2>喜剧片：欢乐不断</h2>
<p>《热辣滚烫》和《飞驰人生2》都是笑中带泪的优质喜剧，既有密集的笑点，也有温暖人心的情感内核。</p>

<h2>家庭片：老少皆宜</h2>
<p>《熊出没·逆转时空》是亲子观影的不错选择，轻松幽默又富有想象力。</p>`,
    category: "影评",
    author: "电影达人小王",
    date: "2026-07-15",
    readCount: 8920,
    image: "https://readdy.ai/api/search-image?query=Summer%20movie%20theater%20entrance%20with%20colorful%20posters%2C%20bright%20sunny%20day%2C%20people%20walking%20in%2C%20warm%20summer%20vibe%2C%20cinematic%20composition%2C%20clean%20minimal%20aesthetic&width=1200&height=600&seq=article-img-03&orientation=landscape",
    slug: "shuqi-dang-zhinan",
    tags: ["暑期档", "观影指南", "电影推荐"]
  },
  {
    id: 4,
    title: "张艺谋《第二十条》：一部关于正义与良知的时代答卷",
    summary: "张艺谋最新力作《第二十条》以刑法正当防卫条款为切入点，探讨了法律与人性的深刻命题。",
    content: `<p>张艺谋导演的《第二十条》是一部聚焦法律题材的现实主义力作。影片以刑法第二十条"正当防卫"为核心，通过一起争议性案件，深入探讨了公平正义的时代命题。</p>

<h2>深刻的社会议题</h2>
<p>影片触及了"见义勇为"与"正当防卫"的边界问题，这是近年来社会关注的热点。张艺谋以他独特的视角，呈现了法理与人情的复杂交织。</p>

<h2>出色的演员阵容</h2>
<p>雷佳音、马丽、赵丽颖等实力派演员的精彩演绎，让影片的情感张力十足。每一个角色都有血有肉，让人感同身受。</p>`,
    category: "影评",
    author: "老张说电影",
    date: "2026-06-30",
    readCount: 15600,
    image: "https://readdy.ai/api/search-image?query=Legal%20drama%20film%20concept%2C%20scales%20of%20justice%20and%20gavel%20on%20wooden%20desk%2C%20warm%20dramatic%20lighting%2C%20cinematic%20composition%2C%20serious%20tone%2C%20clean%20minimal%20background&width=1200&height=600&seq=article-img-04&orientation=landscape",
    slug: "zhangyimou-diertiao",
    tags: ["张艺谋", "第二十条", "法律", "现实主义"]
  },
  {
    id: 5,
    title: "从《流浪地球》到《封神》：中国电影工业化的进阶之路",
    summary: "回顾中国电影工业化的发展历程，从特效技术到制片体系，中国电影正在以前所未有的速度追赶世界一流水平。",
    content: `<p>如果说《流浪地球》开启了中国科幻电影的大门，那么《封神》系列则代表了中国电影工业化的又一次飞跃。</p>

<h2>特效技术的飞跃</h2>
<p>从早期的五毛特效到如今的国际水准，中国电影特效行业经历了脱胎换骨的变化。《流浪地球》系列和《封神》系列正是这一进步的集中体现。</p>

<h2>制片体系的完善</h2>
<p>工业化不仅仅是技术问题，更是制片体系的全面升级。从前期策划到后期制作，中国电影正在逐步建立起标准化的工业流程。</p>`,
    category: "资讯",
    author: "影视观察员",
    date: "2026-06-20",
    readCount: 10200,
    image: "https://readdy.ai/api/search-image?query=Film%20production%20studio%20with%20professional%20equipment%2C%20green%20screen%20and%20cameras%2C%20warm%20cinematic%20lighting%2C%20behind%20the%20scenes%20atmosphere%2C%20clean%20minimal%20composition&width=1200&height=600&seq=article-img-05&orientation=landscape",
    slug: "zhongguo-dianying-gongyehua",
    tags: ["中国电影", "工业化", "特效", "流浪地球"]
  },
  {
    id: 6,
    title: "免费在线观影：如何选择合适的电影网站",
    summary: "在众多免费电影网站中，如何选择一个资源丰富、播放流畅、体验出色的平台？这份指南帮你做出明智选择。",
    content: `<p>随着互联网的发展，在线观影已经成为人们日常娱乐的重要方式。面对众多的免费电影网站，如何选择一个靠谱的平台呢？</p>

<h2>资源丰富度</h2>
<p>一个好的电影网站应该拥有丰富的影视资源，涵盖最新院线大片、经典老片、国产剧、欧美影视等全品类内容。</p>

<h2>播放体验</h2>
<p>高清画质、流畅播放、多端适配是基本要求。无需下载任何软件或插件，打开浏览器就能看，才是最好的体验。</p>

<h2>用户体验</h2>
<p>简洁的界面设计、便捷的搜索功能、清晰的分类导航，这些都能大大提升观影体验。注册不是必须的，简单直接才是王道。</p>`,
    category: "资讯",
    author: "电影达人小王",
    date: "2026-06-10",
    readCount: 31200,
    image: "https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20movie%2C%20cozy%20living%20room%2C%20warm%20ambient%20lighting%2C%20comfortable%20atmosphere%2C%20clean%20minimal%20interior%20design&width=1200&height=600&seq=article-img-06&orientation=landscape",
    slug: "xuanze-dianying-wangzhan",
    tags: ["电影网站", "在线观影", "观影指南"]
  }
];

export const getArticleBySlug = (slug: string) => articles.find(a => a.slug === slug);